/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface imageLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
}
export interface mobileImageStruct {
  image ? : Asset;
}
export interface assetModeStruct {
  field ? : string;
  image: Asset;
  alt ? : string;
  imageTitle ? : string;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  imageLink ? : Array < imageLinkStruct > ;
  mobileImage ? : Array < mobileImageStruct > ;
  media: Asset;
  enableAutoplay ? : boolean;
  enableFullscreen ? : boolean;
  enableDownload ? : boolean;
  muted ? : boolean;
  disablePicInPic ? : boolean;
  inlineOnly ? : boolean;
  playback: string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface ctaLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  ctaText ? : string;
  ctaTextColor ? : number;
  buttonColor ? : number;
  borderColor ? : number;
}
export interface myKikBadgeStruct {
  horizontalPosition: string;
  verticalPosition: string;
}
export interface itemsStruct {
  assetMode ? : assetModeStruct;
  contentAlignment: string;
  title ? : string;
  titleColor ? : number;
  subTitle ? : string;
  subtitleColor ? : number;
  legalTitle ? : string;
  legalText ? : string;
  enableLegalDisclaimer ? : boolean;
  titleOrSubtitle ? : string;
  ctaLink ? : Array < ctaLinkStruct > ;
  myKikBadge ? : Array < myKikBadgeStruct > ;
}
export default interface TileDisplay {
  autoplay ? : boolean;
  autoplayTime ? : string;
  items ? : Array < itemsStruct > ;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  autoplay: Boolean,
  autoplayTime: String,
  items: Array as() => Array < itemsStruct > ,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  autoplay: Boolean,
  autoplayTime: String,
  items: Object,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class TileDisplayBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class TileDisplayInstance implements TileDisplay {
      autoplay ? : boolean;
      autoplayTime ? : string;
      items ? : Array < itemsStruct > ;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.items) {
          this.items = Object.entries(this.items)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'items' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.items.length; i1++) {

            if (this.items[i1]) {
              if (this.items[i1].assetMode) {
                if (typeof this.items[i1].assetMode.image === 'object') {
                  this.items[i1].assetMode.image = {
                    ...this.items[i1].assetMode.image,
                    link: this.items[i1].assetMode.image['@link'],
                    name: this.items[i1].assetMode.image['@name'],
                    path: this.items[i1].assetMode.image['@path'],
                  };
                } else {
                  this.items[i1].assetMode.image = null as any;
                }
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].assetMode) {
                if (this.items[i1].assetMode.mobileAspectRatio) {
                  this.items[i1].assetMode.mobileAspectRatio = Object.entries(this.items[i1].assetMode.mobileAspectRatio)
                    .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
                    .map((pair: [string, any]) => ({
                      ...pair[1]
                    }));
                } else {
                  this.items[i1].assetMode.mobileAspectRatio = null as any;
                }
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].assetMode) {
                if (this.items[i1].assetMode.imageLink) {
                  this.items[i1].assetMode.imageLink = Object.entries(this.items[i1].assetMode.imageLink)
                    .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'imageLink' + '[0123456789]+')))
                    .map((pair: [string, any]) => ({
                      ...pair[1]
                    }));
                  for (let i2 = 0; i2 < this.items[i1].assetMode.imageLink.length; i2++) {

                    if (this.items[i1]) {
                      if (this.items[i1].assetMode) {
                        if (this.items[i1].assetMode.imageLink[i2]) {
                          if (this.items[i1].assetMode.imageLink[i2].switchable) {
                            if (typeof this.items[i1].assetMode.imageLink[i2].switchable.download === 'object') {
                              this.items[i1].assetMode.imageLink[i2].switchable.download = {
                                ...this.items[i1].assetMode.imageLink[i2].switchable.download,
                                link: this.items[i1].assetMode.imageLink[i2].switchable.download['@link'],
                                name: this.items[i1].assetMode.imageLink[i2].switchable.download['@name'],
                                path: this.items[i1].assetMode.imageLink[i2].switchable.download['@path'],
                              };
                            } else {
                              this.items[i1].assetMode.imageLink[i2].switchable.download = null as any;
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  this.items[i1].assetMode.imageLink = null as any;
                }
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].assetMode) {
                if (this.items[i1].assetMode.mobileImage) {
                  this.items[i1].assetMode.mobileImage = Object.entries(this.items[i1].assetMode.mobileImage)
                    .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileImage' + '[0123456789]+')))
                    .map((pair: [string, any]) => ({
                      ...pair[1]
                    }));
                  for (let i2 = 0; i2 < this.items[i1].assetMode.mobileImage.length; i2++) {
                    if (this.items[i1]) {
                      if (this.items[i1].assetMode) {
                        if (this.items[i1].assetMode.mobileImage[i2]) {
                          if (typeof this.items[i1].assetMode.mobileImage[i2].image === 'object') {
                            this.items[i1].assetMode.mobileImage[i2].image = {
                              ...this.items[i1].assetMode.mobileImage[i2].image,
                              link: this.items[i1].assetMode.mobileImage[i2].image['@link'],
                              name: this.items[i1].assetMode.mobileImage[i2].image['@name'],
                              path: this.items[i1].assetMode.mobileImage[i2].image['@path'],
                            };
                          } else {
                            this.items[i1].assetMode.mobileImage[i2].image = null as any;
                          }
                        }
                      }
                    }
                  }
                } else {
                  this.items[i1].assetMode.mobileImage = null as any;
                }
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].assetMode) {
                if (typeof this.items[i1].assetMode.media === 'object') {
                  this.items[i1].assetMode.media = {
                    ...this.items[i1].assetMode.media,
                    link: this.items[i1].assetMode.media['@link'],
                    name: this.items[i1].assetMode.media['@name'],
                    path: this.items[i1].assetMode.media['@path'],
                  };
                } else {
                  this.items[i1].assetMode.media = null as any;
                }
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].ctaLink) {
                this.items[i1].ctaLink = Object.entries(this.items[i1].ctaLink)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'ctaLink' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
                for (let i2 = 0; i2 < this.items[i1].ctaLink.length; i2++) {

                  if (this.items[i1]) {
                    if (this.items[i1].ctaLink[i2]) {
                      if (this.items[i1].ctaLink[i2].switchable) {
                        if (typeof this.items[i1].ctaLink[i2].switchable.download === 'object') {
                          this.items[i1].ctaLink[i2].switchable.download = {
                            ...this.items[i1].ctaLink[i2].switchable.download,
                            link: this.items[i1].ctaLink[i2].switchable.download['@link'],
                            name: this.items[i1].ctaLink[i2].switchable.download['@name'],
                            path: this.items[i1].ctaLink[i2].switchable.download['@path'],
                          };
                        } else {
                          this.items[i1].ctaLink[i2].switchable.download = null as any;
                        }
                      }
                    }
                  }
                }
              } else {
                this.items[i1].ctaLink = null as any;
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].myKikBadge) {
                this.items[i1].myKikBadge = Object.entries(this.items[i1].myKikBadge)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'myKikBadge' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
              } else {
                this.items[i1].myKikBadge = null as any;
              }
            }
          }
        } else {
          this.items = null as any;
        }
      }
    }
    return new TileDisplayInstance(props);
  }
}
